import * as BABYLON from "babylonjs";
import { FrameTime } from "../../earth/earthEngine";
import { EarthMeshPart } from "./earthMeshPart";

export class EarthMesh extends BABYLON.Mesh {
    parts: EarthMeshPart[];
    color: BABYLON.Vector3 = new BABYLON.Vector3(1.0, 1.0, 1.0);

    constructor(scene: BABYLON.Scene) {
        super("Earth", scene);

        this.parts = [];
        this.parts.push(new EarthMeshPart("EarthPartN1", scene, 90.0, 0.0, -180.0, -90.0, "earthSurfaceN1"));
        this.parts.push(new EarthMeshPart("EarthPartN2", scene, 90.0, 0.0, -90.0, 0.0, "earthSurfaceN2"));
        this.parts.push(new EarthMeshPart("EarthPartN3", scene, 90.0, 0.0, 0.0, 90.0, "earthSurfaceN3"));
        this.parts.push(new EarthMeshPart("EarthPartN4", scene, 90.0, 0.0, 90.0, 180.0, "earthSurfaceN4"));
        this.parts.push(new EarthMeshPart("EarthPartS1", scene, 0.0, -90.0, -180.0, -90.0, "earthSurfaceS1"));
        this.parts.push(new EarthMeshPart("EarthPartS2", scene, 0.0, -90.0, -90.0, 0.0, "earthSurfaceS2"));
        this.parts.push(new EarthMeshPart("EarthPartS3", scene, 0.0, -90.0, 0.0, 90.0, "earthSurfaceS3"));
        this.parts.push(new EarthMeshPart("EarthPartS4", scene, 0.0, -90.0, 90.0, 180.0, "earthSurfaceS4"));
        this.parts.forEach(it => it.parent = this);
    }

    update(time: FrameTime) {
        this.parts.forEach(element => {element.materialColor = this.color; });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/earthMesh.ts